class SingleProduitFiche {

	constructor(){ 
		this.component = document.querySelectorAll('[data-component="sliderPhotos"]');
    
		if(this.component.length > 0){
			this.nbSLide = this.component.length;
			this.currentSlide = 1;
			this.triggerNext = document.querySelector('[data-trigger="more-list-next"]');
			this._init();
		}
	}

	_init(){
		this._changeSlide();

		this.triggerNext.addEventListener('click', ()=>{
			if(this.nbSLide !== this.currentSlide){
				this.currentSlide ++;
				this._changeSlide();
			} else{
				this.currentSlide --;
				this._changeSlide();
			}
		});
	}

	_changeSlide(){
		for (let i = 1; i <= this.component.length; i++) {
			const elem = this.component[i - 1];
			if(i === this.currentSlide){
				elem.classList.add('visible');
				this.triggerNext.classList.add('reverse');
			} else{
				elem.classList.remove('visible');
				this.triggerNext.classList.remove('reverse');
			}
		}
	}

}

export const singleProduitFiche = new SingleProduitFiche();